export default [
  {
    path: '/delivery-mans',
    name: 'delivery-man-list',
    component: () => import('@/views/users/deliveryMans/Index.vue'),
    meta: {
      pageTitle: 'Liste des livreurs',
      pageDesc: 'Consultez, filtrez et gérez les livreurs de votre flotte logistique. Utilisez les filtres avancés pour affiner la recherche.',
      breadcrumb: [
        {
          text: 'Livreurs',
          active: true,
          ariaLabel: 'Page active : liste des livreurs',
        },
      ],
      breadcrumbLabel: 'Liste des livreurs',
      resource: 'Auth',
      roles: ['admin', 'superadmin', 'manager'],
      requireLogin: true,
    },
  },
  {
    path: '/delivery-mans/create',
    name: 'delivery-man-create',
    component: () => import('@/views/users/deliveryMans/Create.vue'),
    meta: {
      pageTitle: 'Ajouter un livreur',
      pageDesc: 'Ajoutez un nouveau livreur à votre flotte logistique. Remplissez tous les champs obligatoires et validez.',
      breadcrumb: [
        {
          text: 'Livreurs',
          to: { name: 'delivery-man-list' },
          ariaLabel: 'Retour à la liste des livreurs',
        },
        {
          text: 'Ajouter',
          active: true,
          ariaLabel: 'Page active : ajout d\'un livreur',
        },
      ],
      breadcrumbLabel: 'Ajouter un livreur',
      resource: 'Auth',
      requireLogin: true,
      roles: ['admin', 'superadmin'],
      admin: true,
    },
  },
  {
    path: '/delivery-mans/edit/:id',
    name: 'delivery-man-edit',
    component: () => import('@/views/users/deliveryMans/Edit.vue'),
    meta: {
      pageTitle: 'Modifier un livreur',
      pageDesc: 'Modifiez les informations d\'un livreur existant pour garantir la cohérence logistique.',
      breadcrumb: [
        {
          text: 'Livreurs',
          to: { name: 'delivery-man-list' },
          ariaLabel: 'Retour à la liste des livreurs',
        },
        {
          text: 'Modifier',
          active: true,
          ariaLabel: 'Page active : modification d\'un livreur',
        },
      ],
      breadcrumbLabel: 'Modifier un livreur',
      resource: 'Auth',
      roles: ['admin', 'superadmin'],
      requireLogin: true,
      admin: true,
    },
  },
  {
    path: '/delivery-mans/show/:id',
    name: 'delivery-man-show',
    component: () => import('@/views/users/deliveryMans/Show.vue'),
    meta: {
      pageTitle: 'Détails du livreur',
      pageDesc: 'Consultez les informations détaillées d\'un livreur de la flotte logistique.',
      breadcrumb: [
        {
          text: 'Livreurs',
          to: { name: 'delivery-man-list' },
          ariaLabel: 'Retour à la liste des livreurs',
        },
        {
          text: 'Détails',
          active: true,
          ariaLabel: 'Page active : détails du livreur',
        },
      ],
      breadcrumbLabel: 'Détails du livreur',
      resource: 'Auth',
      roles: ['admin', 'superadmin', 'manager', 'accountant'],
      requireLogin: true,
    },
  },
  {
    path: '/delivery-mans/show/:id/info',
    name: 'users-delivery-mans-showinfo',
    component: () => import('@/views/users/deliveryMans/ShowInfo.vue'),
    meta: {
      pageTitle: 'Information du livreur',
      pageDesc: 'Consultez les informations complémentaires d\'un livreur.',
      breadcrumb: [
        {
          text: 'Livreurs',
          to: { name: 'delivery-man-list' },
          ariaLabel: 'Retour à la liste des livreurs',
        },
        {
          text: 'Information',
          active: true,
          ariaLabel: 'Page active : information complémentaire du livreur',
        },
      ],
      breadcrumbLabel: 'Information du livreur',
      resource: 'Auth',
      roles: ['admin', 'superadmin', 'manager', 'accountant'],
      requireLogin: true,
    },
  },
]
